import { render, staticRenderFns } from "./ParticipantAdditionalItems.vue?vue&type=template&id=2af30640&scoped=true"
import script from "./ParticipantAdditionalItems.vue?vue&type=script&lang=js"
export * from "./ParticipantAdditionalItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af30640",
  null
  
)

export default component.exports